import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-single-company',
  templateUrl: './single-company.component.html',
  styleUrls: ['./single-company.component.css']
})
export class SingleCompanyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
